/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { VitalParameterUnit } from './unit.model';

export interface Trends {
  readonly trends: readonly Trend[];
}

export interface Trend {
  readonly liveMission: number;
  readonly device: number;
  readonly timeSeries: readonly TimeSeriesEntry[];
}

export interface TimeSeriesEntry {
  readonly timestamp: number;
  readonly values: readonly VitalParameterValue[];
}

export interface VitalParameterValue {
  code: VitalParameterCode;
  unit: VitalParameterUnit;
  value: number;
}

/* Vital parameter codes from  "TrendsHistory" of corpuls.mission LIVE */

type VitalParameterBasicCode =
  | 'HR'
  | 'PP'
  | 'SPO2'
  | 'PI'
  | 'CO2'
  | 'RR'
  | 'TEMP1'
  | 'TEMP2'
  | 'SPCO'
  | 'SPMET'
  | 'SPHB';

const VITAL_PARAMETER_BLOOD_PRESSURE = ['NIBP', 'IBP_P1', 'IBP_P2', 'IBP_P3', 'IBP_P4'] as const;

enum BloodPressureSubType {
  SYSTOLIC = 'SYS',
  DIASTOLIC = 'DIA',
  MAP = 'MAP',
}

const VITAL_PARAMETER_BLOOD_PRESSURE_CODES = VITAL_PARAMETER_BLOOD_PRESSURE.flatMap((key) =>
  Object.values(BloodPressureSubType).map((subKey) => `${key}_${subKey}` as const)
);

export type VitalParameterBloodPressureCode = (typeof VITAL_PARAMETER_BLOOD_PRESSURE_CODES)[number];
export type VitalParameterCode = VitalParameterBasicCode | VitalParameterBloodPressureCode;

// Convert a VitalParameterValue in Trends format (code) to a VitalParameterValue in Vitalprameter format (type).
// The value is rounded to the next whole number, since the relevant Vitalparameters do not allow fractions.
export function trendsParameterValueToVitalParameterValueRounded(parameterValue: VitalParameterValue) {
  return {
    type: parameterValue.code,
    value: parameterValue.value != null ? Math.round(parameterValue.value) : null,
    unit: parameterValue.unit,
  };
}
